module.exports = __webpack_public_path__ + "img/mapfre.cf184204.webp";